module.exports = __webpack_public_path__ + "static/visual_6_2_dont-71c1a049b7b10aa4112dfb7ae826333e.png";